import { PropertyType } from '@consumer/graphql'

export enum PREFERRED_LOCATIONS {
  FrontDoor = 'Front Door',
  BackDoor = 'Back Door',
  SidePorch = 'Side Porch',
  Garage = 'Garage',
  Mailroom = 'Mailroom',
  PropertyStaff = 'Property Staff',
  LoadingDock = 'Loading Dock',
  NoPreference = '',
  NotSet = 'Not Set',
}

export enum LOCATION_TYPE {
  Place,
  Person,
}

/** Place-vs-Person classification for each preferred delivery location. */
export const preferredLocationTypes: Record<PREFERRED_LOCATIONS, LOCATION_TYPE> = {
  [PREFERRED_LOCATIONS.FrontDoor]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.BackDoor]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.SidePorch]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.Garage]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.Mailroom]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.PropertyStaff]: LOCATION_TYPE.Person,
  [PREFERRED_LOCATIONS.LoadingDock]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.NoPreference]: LOCATION_TYPE.Place,
  [PREFERRED_LOCATIONS.NotSet]: LOCATION_TYPE.Place,
}

/**
 * Ordered lists of available preferred locations per residential/commercial
 * property type. Each app may keep its own ordering; this list reflects the
 * CMA-canonical order and is provided here as a shared baseline.
 */
export const preferredLocationsByPropertyType: Record<PropertyType, PREFERRED_LOCATIONS[]> = {
  [PropertyType.House]: [
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.BackDoor,
    PREFERRED_LOCATIONS.SidePorch,
    PREFERRED_LOCATIONS.Garage,
  ],
  [PropertyType.Apartment]: [
    PREFERRED_LOCATIONS.Mailroom,
    PREFERRED_LOCATIONS.PropertyStaff,
    PREFERRED_LOCATIONS.LoadingDock,
    PREFERRED_LOCATIONS.Garage,
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.SidePorch,
  ],
  [PropertyType.Business]: [
    PREFERRED_LOCATIONS.Mailroom,
    PREFERRED_LOCATIONS.PropertyStaff,
    PREFERRED_LOCATIONS.LoadingDock,
    PREFERRED_LOCATIONS.Garage,
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.SidePorch,
  ],
  [PropertyType.Other]: [
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.BackDoor,
    PREFERRED_LOCATIONS.SidePorch,
    PREFERRED_LOCATIONS.Garage,
    PREFERRED_LOCATIONS.Mailroom,
    PREFERRED_LOCATIONS.PropertyStaff,
    PREFERRED_LOCATIONS.LoadingDock,
  ],
}

/** Converts a raw string from the API to its PREFERRED_LOCATIONS enum member. */
export function preferredLocationFromString(s: string | undefined): PREFERRED_LOCATIONS {
  switch (s) {
    case 'Front Door':
      return PREFERRED_LOCATIONS.FrontDoor
    case 'Back Door':
      return PREFERRED_LOCATIONS.BackDoor
    case 'Side Porch':
      return PREFERRED_LOCATIONS.SidePorch
    case 'Garage':
      return PREFERRED_LOCATIONS.Garage
    case 'Mailroom':
      return PREFERRED_LOCATIONS.Mailroom
    case 'Property Staff':
      return PREFERRED_LOCATIONS.PropertyStaff
    case 'Loading Dock':
      return PREFERRED_LOCATIONS.LoadingDock
    case 'Not Set':
      return PREFERRED_LOCATIONS.NotSet
    default:
      return PREFERRED_LOCATIONS.NoPreference
  }
}
